var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8623 1.66676C10.5378 1.66573 10.2163 1.7292 9.91644 1.85347C9.61662 1.97774 9.34448 2.16035 9.11583 2.39068L2.34041 9.16551C2.2535 9.25256 2.19633 9.36485 2.17708 9.48634L1.67366 12.6585C1.65915 12.7495 1.6664 12.8427 1.69484 12.9303C1.72327 13.018 1.77207 13.0977 1.83724 13.1629C1.9024 13.228 1.98208 13.2768 2.06975 13.3053C2.15741 13.3337 2.25057 13.3409 2.34158 13.3264L5.51666 12.823C5.63815 12.8038 5.75045 12.7466 5.83749 12.6597L12.6094 5.88426C12.9549 5.53848 13.1901 5.098 13.2852 4.61855C13.3803 4.1391 13.331 3.64221 13.1437 3.19074C12.9564 2.73927 12.6394 2.3535 12.2327 2.08222C11.8261 1.81095 11.3482 1.66637 10.8594 1.66676H10.8623ZM5.14333 11.7001L2.94999 12.0501L3.29999 9.85851L8.19416 4.96376L10.0387 6.80826L5.14333 11.7001ZM11.7846 5.05943L10.8629 5.98343L9.01666 4.13718L9.93891 3.21551C10.1873 2.97841 10.5175 2.84612 10.8609 2.84612C11.2043 2.84612 11.5344 2.97841 11.7828 3.21551C11.904 3.33654 12.0001 3.48026 12.0657 3.63845C12.1312 3.79665 12.165 3.96622 12.165 4.13747C12.165 4.30872 12.1312 4.47829 12.0657 4.63648C12.0001 4.79468 11.904 4.9384 11.7828 5.05943H11.7846Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.91dceb88adb21661228ba3afaf5c5328.svg";
export { ForwardRef as ReactComponent };